"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MessageSquare, Briefcase, Sofa, Sparkles, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Beinmanschette 12-Kammer - Oberschenkel und Wade",
  icon: MessageSquare
}, {
  title: "Armmanschette - Arm und Hand",
  icon: Briefcase
}, {
  title: "Hüftmanschette - Leisten- und Genitalödeme",
  icon: Sofa
}, {
  title: "Kompressionshose 24-Kammer - Ganzbein-Therapie",
  icon: Sparkles
}];
export default function TreatmentFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}